module.exports = __webpack_public_path__ + "static/media/CS3 -- 2.42d634fc.jpg";